import { useApplicationContext } from '../../../../../../../../../../../context/ApplicationContext/ApplicationContext';
import { Message } from '../../../../../../../../../../contexts/chatSocket/reducer/chatSocketReducer.types';
import { MessageType } from '../../../../../../../../../../types/chat.types';
import FileMessage from './components/FileMessage/FileMessage';
import ImageOrVideoMessage from './components/ImageOrVideoMessage/ImageOrVideoMessage';
import TextMessage from './components/TextMessage/TextMessage';
import VideoCallMessage from './components/VideoCallMessage/VideoCallMessage';

interface ChatMessageByMessageTypeProps {
  message: Message;
}

const ChatMessageByMessageType = ({ message }: ChatMessageByMessageTypeProps) => {
  const { team } = useApplicationContext();

  const isMessageOfUser = message.user.id === team?.userId;

  if (message.type === MessageType.MESSAGE) {
    return (
      <TextMessage
        message={message.body}
        hasError={!!message.error}
        isSending={!!(message.tempId && !message.id)}
        isMessageOfUser={isMessageOfUser}
      />
    );
  }

  if (message.type === MessageType.FILE) {
    return <FileMessage message={message} isMessageOfUser={isMessageOfUser} />;
  }

  if (message.type === MessageType.VIDEO_CALL) {
    return <VideoCallMessage message={message} />;
  }

  if (message.type === MessageType.IMAGE_OR_VIDEO) {
    return <ImageOrVideoMessage isMessageOfUser={isMessageOfUser} message={message} />;
  }

  return null;
};

export default ChatMessageByMessageType;
